export const meta = {
  title: '代理代码与推荐：注册时那个代码，说清楚',
  updatedAt: '2026-07-17',
  related: ['getting-started', 'billing'],
};

网络有独立的销售代理，负责介绍洗车店运营者。如果是代理为您办理的注册，您多半是通过他们的链接或 QR 码进来的——或者在注册表单里输入了他们的代码。这里说清楚那个代码做了什么，以及它永远不会做什么。

## 代码做了什么

代理代码在**注册那一刻**把代理与您的账户关联。通过代理链接进入时，提交前页面会显示代理姓名的横幅——谁获得业绩，您始终清楚。手动输入的代码同样会校验；无效代码不会产生任何关联。

## 它让您花多少钱：零

您的订阅价格**有没有代码完全一样**——同样的套餐、同样的试用、同样的账单。代理的佣金由网络一侧支付；绝不会加到您的账单上，也根本不存在什么“代理附加费”。

## 代理如何获得报酬——仅一次

模式刻意做得简单：代理**每笔注册只赚一次佣金**，金额等于您一个月的订阅费，由您的**第一张已付款账单**触发。此后再无任何——没有持续抽成，没有您未来账单的任何份额。如果试用始终没有转为付费账单，就一分佣金也不会支付。

有些代理本身是由招募人引荐的；那种情况下，招募人也会就该笔注册获得一笔固定的一次性款项。规则相同：每笔注册仅一次，由网络支付，绝不出自您的口袋。

## 之后还能补加代码吗？

不能——归属在注册时就已固定，事后无法附加到已有账户。如果有代理帮过您、而您是手动输入代码，请在提交注册表单之前填好。

## 成为代理

任何人都可以：本站的**成为代理**页只需两分钟。您会立刻拿到代码、分享链接和可打印的 QR 页，当天就能开始推荐。当您介绍的运营者付清第一张账单时，收益会记入您的代理后台；款项通过 DuitNow 转账发放，但需先完成身份验证（KYC）——验证前可以累积收益，只是不能提取。
